import { IAccount } from '../models';

export const storeAccount = (account: any) => {
  window.localStorage.setItem('account', JSON.stringify(account));
};

export const processTokenResult = (
  login: string,
  result: any,
  onSuccessCallback?: (token?: string) => any,
  onErrorCallback?: () => any
) => {
  const { userId, token, expiresInSeconds } = result.data;

  if (token && expiresInSeconds) {
    const expirationDate = new Date();
    expirationDate.setSeconds(expirationDate.getSeconds() + expiresInSeconds);
    const account: IAccount = {
      userName: login,
      expires: expirationDate,
      accessToken: `Bearer ${token}`,
      userId
    };
    storeAccount(account);
    if (onSuccessCallback) {
      onSuccessCallback(token);
    }
  } else if (onErrorCallback) {
    onErrorCallback();
  }
};

const forceLoginRedirect = () => {
  storeAccount(null);
  window.location.reload();
};

export const getAccount = (
  tokenRefreshHandler?: (account: IAccount) => void
): IAccount => {
  const account: IAccount = JSON.parse(window.localStorage.getItem('account'));

  if (account) {
    const checkDate = new Date(account.expires);
    const now = new Date();
    const timeDiff = (checkDate.getTime() - now.getTime()) / 1000;

    if (timeDiff > 60 && timeDiff < 120 && tokenRefreshHandler) {
      tokenRefreshHandler(account);
    } else if (timeDiff <= 60) {
      forceLoginRedirect();
    }
  }

  return account;
};

export const logout = () => {
  storeAccount(null);
  window.location.reload();
};

export default {
  getAccount,
  storeAccount,
  processTokenResult,
  logout
};
